<ng-container>
    <div class="overlay-warp">
        <div class="itemx">
            <div class="item-list">
                <div class="choose" [ngClass]="{'selected': valueControl.value === true}" (click)="select(true)">
                    <div class="inner-selected">
                        <img src="/assets/images/auto-fill/vi.svg">
                    </div>
                </div>
                <p translate (click)="select(true)">grid.reports.clientChargeYes</p>
            </div>
        </div>
        <div class="itemx">
            <div class="item-list">
                <div class="choose" [ngClass]="{'selected': valueControl.value === false}" (click)="select(false)">
                    <div class="inner-selected">
                        <img src="/assets/images/auto-fill/vi.svg">
                    </div>
                </div>
                <p translate (click)="select(false)">grid.reports.clientChargeNo</p>
            </div>
        </div>
    </div>
</ng-container>
